import posthog from 'posthog-js';
import type { Me } from '../api/types.js';

/**
 * Produktová analytika (PostHog EU) — JEN v produkčním buildu a JEN když je
 * nastavený klíč (env VITE_POSTHOG_KEY při buildu; bez něj vše no-op, takže
 * dev ani testy nic neposílají). Zásady:
 * - žádná PII: identifikace přes userId (cuid) + role + firmaId, nikdy
 *   jméno/e-mail;
 * - finanční zeď platí i tady: session replay maskuje všechny inputy
 *   a texty označené `.ph-mask` (částky, marže, ceníky);
 * - před ostrým provozem (mimo demo) doplnit souhlas — viz KG.
 */

const KLIC = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
// `||` (ne `??`): nenastavený build-arg dorazí jako PRÁZDNÝ string, ne undefined.
const HOST =
  (import.meta.env.VITE_POSTHOG_HOST as string | undefined) || 'https://eu.i.posthog.com';

export const analytikaZapnuta: boolean = Boolean(KLIC) && import.meta.env.PROD;

export function initAnalytiku(): void {
  if (!analytikaZapnuta || !KLIC) return;
  posthog.init(KLIC, {
    api_host: HOST,
    // SPA: pageview posíláme sami při změně routy (SledovaniStranek v App).
    capture_pageview: false,
    autocapture: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '.ph-mask',
    },
  });
}

/** SPA pageview — volá se při každé změně routy. */
export function sledujStranku(): void {
  if (!analytikaZapnuta) return;
  posthog.capture('$pageview');
}

/** Doménová událost (funnel) — názvy česky, snake_case. */
export function sledujUdalost(nazev: string, vlastnosti?: Record<string, unknown>): void {
  if (!analytikaZapnuta) return;
  posthog.capture(nazev, vlastnosti);
}

/** Po přihlášení/obnově session: anonymní identita = userId + role + firma. */
export function identifikujUzivatele(me: Me): void {
  if (!analytikaZapnuta) return;
  posthog.identify(me.userId, { role: me.role.join(','), firmaId: me.firmaId });
  posthog.group('firma', me.firmaId);
}

/** Odhlášení — odpojit identitu (další uživatel na zařízení = nová persona). */
export function resetAnalytiku(): void {
  if (!analytikaZapnuta) return;
  posthog.reset();
}
